import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=bc125784&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=bc125784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc125784",
  null
  
)

/* custom blocks */
import block0 from "./Dossier.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports